import React from 'react'
import Page from '../templates/empower/wellbeing/spotlight/SpotLight-mental-health-and-wellbeing'
import { Helmet } from "react-helmet";

function spotlight() {
  return (
    <div>
      <Helmet>
        <title>
          WOW Counseling and Mental Health | Employee Health Benefits |
          Hirdaramani
        </title>
        <meta
          name="title"
          content="WOW Counseling and Mental Health | Employee Health Benefits | Hirdaramani"
        />
        <meta
          name="description"
          content="Explore Hirdaramani's WOW Counseling Program, providing professional mental health support. In 2023, 1,403 associates accessed services in Sri Lanka."
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/empower/wellbeing/spotlight-mental-health-and-wellbeing/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="Counseling and Mental Health" />
        <meta
          property="og:title"
          content="WOW Counseling and Mental Health | Employee Health Benefits | Hirdaramani"
        />
        <meta
          property="og:description"
          content="Explore Hirdaramani's WOW Counseling Program, providing professional mental health support. In 2023, 1,403 associates accessed services in Sri Lanka."
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/empower/wellbeing/spotlight-mental-health-and-wellbeing/"
        />
      </Helmet>

      <Page />
    </div>
  );
}

export default spotlight
